import HeaderComponent from "../HeaderComponent";
import React, {useContext, useEffect, useState} from "react";
import "../../css/createStory.css"
import Breadcrumb from "../../wrapper/Breadcrumb";
import Footer from "../../assets/Footer";
import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../../services/authenticate";
import axiosInstance from "../../axiosInstance";
import config from "../../Config/config";
import LoginPage from "../login";
import {useNavigate} from "react-router-dom";
import {AmountContext} from "../../Context/AmountContext";
import {Button, Modal} from "react-bootstrap";

const CreateStory = ({searchTerm, setSearchTerm, genres}) => {
    const {setOrderAmount, setWalletBalance, setRemainingAmount} = useContext(
        AmountContext
    );
    const [orderId, setOrderId] = useState([]);
    const [show, setShow] = useState(false);
    const onClose = () => setShow(false);
    const [formData, setFormData] = useState({
        childName: '',
        age: '',
        moral: '',
        interest: '',
        storyLength: 'Medium',
        storyTone: 'Funny',
        favoriteStoryFriend: '',
        dislike: ""
    });
    const [showLogin, setShowLogin] = useState(false);
    const navigate = useNavigate();
    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const [isFree, setIsFree] = useState(false);


    const handleRadioChange = (e) => {
        const {name, value} = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    useEffect(() => {
        fetchFree().then();
    }, [])

    const fetchFree = async () => {
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.get(`${config.api.user}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            })
            if (response.status === 200) {
                const data = response.data;
                setIsFree(data.isUserEligibleForFreeStory)
            }
        } catch (error) {
            if (error.response) {
                console.log("Error Status:", error.response.status);
                if (error.response.status === 401 || error.response.status === 403) {
                    console.log("Unauthorized or forbidden. Attempting token refresh.");
                    const refersToken = getRefreshToken();
                    if (!refersToken) {
                        return;
                    }
                    await refreshIdToken(refersToken);
                    await fetchFree();
                }
            }
        }
    }

    const handleSave = async () => {
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.post(`${config.api.story}`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            })
            if (response.status === 200) {
                setFormData({
                    childName: '',
                    age: '',
                    moral: '',
                    interest: '',
                    storyLength: 'Medium',
                    storyTone: 'Funny',
                    favoriteStoryFriend: '',
                    dislike: "",
                })
                navigate("/storys")
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 402) {
                    const orderId = error.response.data.orderId;
                    setShow(true)
                    setOrderId(orderId)
                }
                console.log("Error Status:", error.response.status);
                if (error.response.status === 401 || error.response.status === 403) {
                    console.log("Unauthorized or forbidden. Attempting token refresh.");
                    const refersToken = getRefreshToken();
                    if (!refersToken) {
                        const userConfirmed = window.confirm(
                            "Please sign in to submit your Story. If you don't have an account, please create one."
                        );
                        if (userConfirmed) {
                            setShowLogin(true);
                            return;
                        }
                    }
                    await refreshIdToken(refersToken);
                    await handleSave();
                }
            }
        }
    }
    const payMent = async ({orderIds}) => {
        const token = getTokenFromSession();
        try {
            const response = await axiosInstance.get(
                `${config.api.payment}?orderId=${orderIds}&pgName=PhonePE`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `${token}`,
                    },
                }
            );

            const data = response.data;
            localStorage.setItem("story", "true")
            if (data.orderAmount) {
                setOrderAmount(data.orderAmount);
                setWalletBalance(data.closingBalance);
                setRemainingAmount(data.remainingAmount);
                navigate("/payment_status");
            } else {
                localStorage.setItem(
                    "merchantTransactionId",
                    data.merchantTransactionId
                );
                const url = data.paymentLink;
                window.location.href = url;
            }
        } catch (error) {
            if (error.response) {
                console.log("Error Status:", error.response.status);
                if (error.response.status === 401 || error.response.status === 403) {
                    console.log("hello");
                    const refersToken = getRefreshToken();
                    await refreshIdToken(refersToken)
                        .then()
                        .catch(() => {
                            sessionStorage.setItem("intendedPage", "/cart");
                            navigate("/login");
                        });
                }
            } else {
                console.log("Error Message:", error.message);
            }
        }
    };
    const confirm = async () => {
        setShow(false);
        await payMent({orderIds: orderId})
    }
    return (
        <div>
            <HeaderComponent
                searchTerm={searchTerm}
                handleSearch={setSearchTerm}
                genres={genres}
            />
            <div style={{marginTop: "200px"}}></div>
            <Breadcrumb
                pages={[
                    {label: "Home", path: "/"},
                    {label: "Story", path: "/story"},
                ]}
            />
            <div className="story-container">
                <div className="story-sen">
                    <p>
                        Bring your child’s imagination to life with stories made just for them—because the most precious
                        memories begin with a story written from the heart.
                    </p>
                </div>
                <div className="area">
                    <div className="child-area">
                        <span className="name-child">Child's Name:</span>
                        <textarea
                            className="name-text"
                            name="childName"
                            value={formData.childName}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="age">
                        <span className="name-child">Age:</span>
                        <textarea
                            className="name-text"
                            name="age"
                            value={formData.age}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="age">
                        <span className="name-child">Moral:</span>
                        <textarea
                            className="name-text"
                            name="moral"
                            value={formData.moral}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="child-area">
                        <label htmlFor="interest" className="label">
                            Interest:
                        </label>
                        <textarea
                            id="interest"
                            className="dropdown-story"
                            name="interest"
                            value={formData.interest}
                            onChange={handleInputChange}
                            placeholder="e.g., Dinosaurs,Space,Princesses,Superheroes,Animals"
                            rows={3}
                        />
                    </div>
                    <div className=" child-area">
                        <label htmlFor="dislike" className=" label">
                            DisLike:
                        </label>
                        <textarea
                            id=" interest"
                            className=" dropdown-story"
                            name="dislike"
                            value={formData.dislike}
                            onChange={handleInputChange}
                            placeholder=" e.g.,loud noises,scary animals,dark"
                            rows={3}
                        />
                    </div>
                    <div className="child-area-column">
                        <label className="label-story">Story Length:</label>
                        <div className="options-group">
                            {["Short", "Medium", "Long"].map((length) => (
                                <label key={length} className="option">
                                    <input
                                        type="radio"
                                        name="storyLength"
                                        value={length}
                                        checked={formData.storyLength === length}
                                        onChange={handleRadioChange}
                                    />
                                    {length}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="child-area-column">
                        <label className="label-story">Story Tone:</label>
                        <div className="options-group">
                            {["Funny", "Adventurous", "Educational", "Magical", "Heartwarming"].map((tone) => (
                                <label key={tone} className="option">
                                    <input
                                        type="radio"
                                        name="storyTone"
                                        value={tone}
                                        checked={formData.storyTone === tone}
                                        onChange={handleRadioChange}
                                    />
                                    {tone}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="child-area">
                        <label className="name-child">Favorite Story Friend:</label>
                        <textarea
                            className="name-text"
                            name="favoriteStoryFriend"
                            value={formData.favoriteStoryFriend}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="area-submit">
                        {isFree ? (
                            <button className="submit-button" onClick={handleSave}>Create Story For Free</button>
                        ) : (
                            <button className="submit-button" onClick={handleSave}>Create</button>
                        )}

                    </div>
                </div>
            </div>
            <LoginPage show={showLogin} handleClose={() => setShowLogin(false)}/>
            <div style={{marginTop: "500px"}}>
                <Footer/>
            </div>
            <Modal show={show} onHide={onClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Insufficient Credits</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        You don’t have enough credits to create the story. Would you like to proceed with payment?
                        <br/>
                        If you have the correct amount in your wallet, the required amount will be automatically
                        deducted.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={confirm}>
                        Proceed with Payment
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default CreateStory;
